import { OtpRoute } from './OTP';
import { HomeRoute } from './Home';
import { DraggableRectRoute } from './DraggableRect';
import { MapLeafletRoute } from './MapLeaflet';
import { MapGoogleRoute } from './MapGoogle';

const routes = [
  HomeRoute,
  OtpRoute,
  DraggableRectRoute,
  MapLeafletRoute,
  MapGoogleRoute,
];

export { routes };